// simple-excel.type.ts

type typeValues = 'string' | 'number' | 'short-date' | 'date' | 'currency' | 'percent';

export interface ColumnsModel {
    columnKey: string;
    columnName: string;
    type?: typeValues;
    width?: number;
}

export interface SheetsModel {
    header: string[];
    data: Object[];
    columns: ColumnsModel[];
    sheetName: string;
    lineBreak: number;
    totalRow?: any;
}

export interface SimpleExcelModel {
    fileName: string;
    sheets: SheetsModel[];
}